import React, { useState, useEffect } from 'react';
import { Container, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  getDoctors,
  getDoctorSchedule,
  getDoctorsJobs,
  getDoctorsMapData,
  getDoctorMapData,
  setCalendarDate,
  getDoctorsByDaysSchedule,
  doctorScheduleDateRangeResize,
} from '../../actions/doctors';

import { fetchPatients } from '../../actions/patientsActions';

import Sticky from 'react-sticky-el';

import Footer from '../components/global/footer';

import DoctorsPageList from './doctorsPageList';

import useDoctorScheduleDateRangeResize from '../../hooks/useDoctorScheduleDateRangeResize';

import ScheduleHeader from '../components/global/List/ScheduleHeaderListv2';
import PaidSearchForm from '../components/global/paidSearchForm';

import { useUrlParser } from '../../utils/useUrlParser';
import { useHistory, NavLink } from "react-router-dom";
import { usePatientsApi } from './doctorsPageList/api';

import HeaderButton from '../components/global/header/button';
import { partnersList, } from '../components/global/footer/helpers';

import { isMobile } from '../../utils/mobile';

const LayoutList = ({
  doctor,
  doctors,
  doctorSchedule,
  getDoctors,
  getDoctorSchedule,
  getDoctorsByDaysSchedule,
  getDoctorsJobs,
  doctorsByDaysSchedule,
  getPatients,
  user,
  doctorScheduleDateRangeResize,
  doctorsJobs,
  patients
}) => {
  
  // usePatientsApi({ getPatients, token: user.token });
  
  useEffect(() => {
    if (user.token) getPatients();
  }, [getPatients, user.token]);

  useDoctorScheduleDateRangeResize({ datesRange: doctorSchedule.datesRange, dateRangeSize: 8, doctorScheduleDateRangeResize });
  
  const urlParser = useUrlParser();
  const history = useHistory();

  const transformParams = (params) => {
    if (!params) return {};
    
    const transformedParams = { ...params };
    
    Object.keys(transformedParams).forEach(key => {
      if (transformedParams[key] === 'true') {
        transformedParams[key] = true;
      } else if (transformedParams[key] === 'false') {
        transformedParams[key] = false;
      }
    });
    
    return transformedParams;
  };
  
  const [searchFilters, setSearchFilters] = useState(transformParams(urlParser.urlData.params));

  
  useEffect(() => {
    // setSearchFilters(transformParams(urlParser.urlData.params));
  }, [urlParser.urlData.params.visit_date]);

  useEffect(() => {
    
    const baseUrl = `/paid`;
    
    // Create query string from search parameters
    const queryParams = new URLSearchParams();
    
    // Add search params to query string
    if (searchFilters?.region_id) queryParams.set('region_id', searchFilters?.region_id);
    if (searchFilters?.city_id) queryParams.set('city_id', searchFilters?.city_id);
    if (searchFilters?.institution_id) queryParams.set('institution_id', searchFilters?.institution_id);
    if (searchFilters?.specialization_id) queryParams.set('specialization_id', searchFilters.specialization_id);
    if (searchFilters?.doctor_id) queryParams.set('doctor_id', searchFilters.doctor_id);
    if (searchFilters?.medical_service_id) queryParams.set('medical_service_id', searchFilters.medical_service_id);
    
    // Combine base URL and query parameters
    const newUrl = `${baseUrl}${queryParams.toString() !== '' ? `?${queryParams.toString()}` : ''}`;
    // Get current URL path + query string
    const currentUrl = `${window.location.pathname}${window.location.search}`;
    
    // Only push to history if the URL has actually changed
    
    if (currentUrl !== newUrl) {
      history.replace(newUrl);
    }
  }, [searchFilters]);
  
  // Wrapper function that updates searchFilters when calendar date changes
  const handleSetCalendarDate = (date) => {
    setSearchFilters(prevFilters => ({
      ...prevFilters,
      visit_date: date
    }));
  }

  
  // Add state to track search form visibility, collapsed by default on mobile
  const [showSearchForm, setShowSearchForm] = useState(!isMobile || !doctorsJobs.loaded);
  
  const [isMobileView, setIsMobileView] = useState(isMobile());
        
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

  // Toggle function for search form visibility
  const toggleSearchForm = () => {
    setShowSearchForm(prev => !prev);
    
    // Reinitialize Sticky component after toggling
    setTimeout(() => {
      // Force sticky component to recalculate its position using window resize event
      window.dispatchEvent(new Event('resize'));
    }, 350); // Wait for transition to complete
  };
  
  return (
    <>
    <div>
      
      <header className="header header--search header--feature">
        <Container>
          <NavLink to="/">
            <div className="logotype">
              <span className="back-to-home">
                <i className="fas fa-arrow-left"></i> Назад
              </span>
            </div>
          </NavLink>

          <h3 className="title-online-visit">
            <div className="info-tooltip-container">
              <i className="fas fa-eye"></i>
              <div className="info-tooltip">
                <h4>Рекомендації щодо пошуку послуги та запису на прийом:</h4>
                <p>1. Обов'язково вкажіть вид послуги, яка Вас цікавить</p>
                <p>2. Обов'язково вкажіть послугу, яка Вас цікавить</p>
                <p>3. Для звуження пошуку Ви можете вказати будь-який інший параметр запиту</p>
                <p>4. У разі пошуку стаціонарного лікування, Ви отримуєте інформацію щодо місця надання такої послуги та лікарів, до яких Вам необхідно записатись для попередньої консультації</p>
              </div>
            </div>
            Онлайн-запис на платне медичне обслуговування</h3>
          
          <a href={partnersList[1].link} className="partners-list__link" target='_blank' rel="noopener noreferrer" style={{ marginRight: '20px' }}>
              <img src={partnersList[1].item} alt={partnersList[1].alt}/>
          </a>
          {!isMobileView && (
          <HeaderButton />
          )}
        </Container>
        
      </header>

      <main className="main-content">
        
        <div className="data-list-wrapper schedule-listv2">
          <Container>
            <div className="tabs-wrapper">
              <Tab.Container activeKey={ "doctors" } onSelect={ "doctors" }>
                {isMobileView  ? (
                    <>
                    <div className={`search-form-container ${showSearchForm ? 'expanded' : 'collapsed'}`}>
                      <PaidSearchForm 
                        searchFilters={searchFilters} 
                        setSearchFilters={setSearchFilters}
                        getDoctorsJobs={getDoctorsJobs}
                      />
                    </div>
                    {/* <div className="search-form-toggle">
                      <button 
                        onClick={toggleSearchForm}
                        className="btn btn-primary"
                        aria-label={showSearchForm ? 'Hide search form' : 'Show search form'}
                      >
                        {showSearchForm ? '▲ Згорнути фільтри' : '▼ Розгорнути фільтри'}
                      </button>
                    </div> */}
                    </>
                  ) : (
                    <>
                      <div className={`search-form-container`}>
                        <PaidSearchForm 
                          searchFilters={searchFilters} 
                          setSearchFilters={setSearchFilters}
                          getDoctorsJobs={getDoctorsJobs}
                        />
                      </div>
                      <Sticky className="sticky-wrapper">
                        {doctorsJobs.loaded && (<div className="navigation">
                          <div className="doctor-name-header">Графік</div>
                          <ScheduleHeader searchFilters={searchFilters} setCalendarDate={handleSetCalendarDate} calendarDate={searchFilters?.visit_date} />    
                          <div className="price-header">Вартість<br/>послуги</div>
                        </div>)}
                      </Sticky>
                    </>
                )}
                
                <Tab.Content>
                  <Tab.Pane eventKey={ "doctors" }>
                    <DoctorsPageList
                      doctor={doctor}
                      doctors={doctors}
                      doctorSchedule={doctorSchedule}
                      doctorsByDaysSchedule={doctorsByDaysSchedule}
                      getDoctors={getDoctors}
                      
                      doctorsJobs={doctorsJobs}
                      getDoctorSchedule={getDoctorSchedule}
                      getDoctorsByDaysSchedule={getDoctorsByDaysSchedule}
                      searchFilters={searchFilters}
                      setSearchFilters={setSearchFilters}
                      user={user}
                      setCalendarDate={handleSetCalendarDate}
                      patients={patients}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Container>
        </div>
      </main>
      <Footer page={"paid"} className="footer-sticky" />
    </div>
    <style>{`
      .tabs-wrapper {
        margin-top: 0px;
      }
      .header--feature {
          padding-bottom: 0;
      }
      .back-to-home {
        display: flex;
        align-items: center;
        color: #094fa3;
        font-size: 16px;
        font-weight: 500;
        transition: color 0.3s ease;
      }
      
      .back-to-home i {
        margin-right: 8px;
        font-size: 14px;
      }
      
      .logotype:hover .back-to-home {
        color: #0a6eeb;
      }

      body, .main-content {
        background: #f7fff7;
      }
      #root > div.mobile {
          margin: 0px 0 70px;
      }
      .footer {
          background: #f7fff7;
      }
      
      .header--search {
        background: #f7fff7;
      }
      .data-list-wrapper {
        background: #f7fff7;
        border-top:0;
      }
      .navigation {
        display: flex;
        align-items: center;
        width: 100%;
        padding-right: 10px; /* Add padding to align with content */
      }
      
      .doctor-name-header {
        width: 235px;
        font-weight: 500;
        text-align: center;
        flex-shrink: 0;
      }
      
      .price-header {
        width: 120px;
        text-align: center;
        font-weight: 500;
        flex-shrink: 0;
        margin-right: 5px; /* Match margin in doctor component */
      }
      
      .navigation > :nth-child(2) {
        flex: 1;
        display: flex;
        justify-content: left;
      }
      
      /* Feature card styling for alignment with headers */
      .feature-card__item {
        display: flex;
        align-items: center;
        width: 100%;
        padding-right: 10px; /* Add padding for content alignment */
        box-sizing: border-box;
      }
      
      /* Add some spacing to match the header styling */
      .medic-feature-profile-price {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .search-form-container.collapsed {
        max-height: 0;
        opacity: 0;
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0;
        visibility: hidden; /* Add visibility hidden for better accessibility */
      }
      
      .search-form-container.expanded {
        max-height: 800px; /* Increased to allow more space */
        opacity: 1;
        margin-bottom: 1rem;
        visibility: visible;
      }
      
      .search-form-toggle {
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
      }
      
      .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(165, 165, 165, 0.46);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
      
      .loading-message {
        text-align: center;
        background-color: rgb(255, 255, 255);
        padding: 2rem;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        max-width: 90%; 
        font-size: 1.25rem;
        color:#094fa3;
      }
      .loading-message p {
        margin: 0;
      }
      .loading-message img {
        padding: 10px 0;
      }
      
      /* Logo styling with modern pastel Ukrainian colors */
      .logo-text {
        font-size: 2.4rem;
        font-weight: 700;
        letter-spacing: -0.5px;
        margin: 0;
        padding: 0;
        line-height: 1;
        text-shadow: 1px 1px 2px rgba(0,0,0,0.05);
      }
      
      .logo-tan {
        color: #5b9bd5; /* Pastel blue */
        background: linear-gradient(135deg, #55aeff, #0080ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      .logo-go {
        color: #f7dc6f; /* Pastel yellow */
        background: linear-gradient(135deg, #d7cb98, #fff80a);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      .logotype {
        display: inline-block;
        position: relative;
        padding: 5px 0;
      }
      
      /* Add a subtle glow effect on hover for interactive feel */
      .logotype:hover .logo-tan {
        background: linear-gradient(135deg, #0080ff, #55aeff);
        -webkit-background-clip: text;
        background-clip: text;
      }
      
      .logotype:hover .logo-go {
        background: linear-gradient(135deg, #fae489, #f7dc6f);
        -webkit-background-clip: text;
        background-clip: text;
      }
      
      .logotype:hover:after {
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        background: linear-gradient(90deg, #78add9 0%, #fae489 100%);
      }

      .price-column {
        width: 120px;
        flex-shrink: 0;
        text-align: center;
        margin-right: 5px;
        border-left: 1px solid #d0e5f0;
      }
      
      /* Tooltip styling */
      .info-tooltip-container {
        position: relative;
        display: inline-block;
        margin-right: 15px;
      }
      
      .info-tooltip-container .fas.fa-eye {
        color: #094fa3;
        font-size: 1.2rem;
        cursor: pointer;
        transition: color 0.3s ease;
        margin-top: 10px;
      }
      
      .info-tooltip-container .fas.fa-eye:hover {
        color: #0a6eeb;
      }
      
      .info-tooltip {
        visibility: hidden;
        width: 350px;
        background-color: #fff;
        color: #333;
        text-align: left;
        border-radius: 8px;
        padding: 15px;
        position: absolute;
        z-index: 1000;
        top: 150%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s, visibility 0.3s;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        border: 1px solid #e0e0e0;
      }
      
      .info-tooltip::after {
        content: "";
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -10px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent #fff transparent;
      }
      
      .info-tooltip-container:hover .info-tooltip {
        visibility: visible;
        opacity: 1;
      }
      
      .info-tooltip h4 {
        margin-top: 0;
        color: #094fa3;
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 10px;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 8px;
      }
      
      .info-tooltip p {
        margin: 8px 0;
        font-size: 0.9rem;
        line-height: 1.4;
      }
    `}</style>
    </>
  );
};

const mapStateToProps = ({
  doctor,
  doctors,
  doctorsMap,
  doctorSchedule,
  doctorsByDaysSchedule,
  divisions,
  divisionsMap,
  user,
  doctorsJobs,
  patients, // Add patients from the Redux store
}) => ({
  doctor,
  doctors,
  doctorsMap,
  doctorSchedule,
  doctorsByDaysSchedule,
  divisions,
  divisionsMap,
  user,
  doctorsJobs,
  patients, // Pass patients to the component
});

const mapDispatchToProps = {
  getDoctors,
  getDoctorsMapData,
  getDoctorMapData,
  getDoctorSchedule,
  getDoctorsByDaysSchedule,
  setCalendarDate,
  getPatients: fetchPatients,
  doctorScheduleDateRangeResize,
  getDoctorsJobs,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutList);
